import TypesOfModelModal from './types-of-model-modal.connect'

export default TypesOfModelModal
